<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <form v-on:submit.prevent class="m-3">
          <validated-input
            label="Media Type"
            type="select"
            class="mr-2 mb-0"
            v-model="item.mediaType"
            :options="options"
            track-by="classType"
            valueField="class_type_name"
            text-field="class_type_name"
            :validate="{ required: true }"
            name="mediaType"
          />
          <validated-input
            label="Order"
            class="mr-2 mb-0"
            v-model="item.order"
            :validate="{ required: true }"
            name="order"
          />
        </form>
      </div>
    </div>

    <div class="d-flex justify-content-between border-top pt-3 p-3">
      <div class="flex-grow">
        <span class="col-md-12 text-danger" v-if="error">{{ error.message }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <b-btn @click="cancel" variant="primary" class="btn btn-light mr-2"> Close </b-btn>
        <b-btn @click="submit" variant="primary" :disabled="errors.any() || pending">
          <i class="far fa-spinner-third fa-spin text-white" v-show="pending"></i>
          Save
        </b-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { classTypes } from '@/constants/media';

export default {
  data() {
    return {
      options: classTypes
    };
  },
  props: {
    error: Object | Boolean,
    item: Object,
    pending: Boolean
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) return console.log(this.errors.any());
      this.$emit('submit', this.item);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
